module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"preview":"Prévisualiser la donnée"},"en":{"preview":"Preview the data"}}')
  delete Component.options._Ctor
}
